<template>
  <div class="goodContainer" v-if="parcelList.length>0">
    <p class="title">包裹明細</p>
    <div class="parcelist">
      <div v-for="(item,index) in parcelList" :key="index" class="gooditem" @click="godetial(item)">
        <p>快遞單號 <span>{{item.expressNumber}}</span></p>
        <p>計費重量
          <md-amount
            :value="item.weight"
            has-separator></md-amount> <span>KG</span>
        </p>
        <p style="padding-bottom: 0.2rem">物品價值 <md-amount
          :value="item.totalPrice"
          has-separator></md-amount><span>CNY</span></p>
        <div class="spacel" v-if="item.type==1">
          <span>特</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Amount } from 'mand-mobile'

export default {
  name: 'GoodModal',
  props: ['parcelList'],
  components: {
    [Amount.name]: Amount
  },
  data () {
    return {
      list: []
    }
  },
  mounted () {

  },
  methods: {
    godetial (item) {
      this.$router.push({ name: 'Packdetail', query: { id: item.id, status: item.status } })
    }
  }
}
</script>

<style lang="less">
  .goodContainer {
    .title {
      font-size: 0.32rem;
      text-align: left;
      padding: 0.32rem;
    }

    .parcelist {
      background-color: white;
      display: flex;
      flex-direction: column;

      .gooditem {
        width: 90%;
        margin-left: 5%;
        border: 1px solid #f0f0f2;
        font-size: 0.32rem;
        margin-top: 0.3rem;
        position: relative;
        p {
          padding-top: 0.2rem;
          text-align: left;
          padding-left: 1rem;
          color: rgba(136, 136, 136, 1);

          span {
            margin-left: 0.3rem;
            color: #333333;
          }
        }
        .spacel{
          position: absolute;
          left: 0;
          top: 0;
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 1rem 1rem 0 0;
          border-color: rgba(82, 204, 111, 1) transparent transparent transparent;
          span{
            position: absolute;
            bottom: .5rem;
            left: 0.2rem;
            font-size:0.28rem;
            color: rgba(255, 255, 255, 1);
          }
        }
      }
    }
  }
</style>
